// 탭 안에서 "앱 안에서 실제로 페이지를 이동한 적이 있는지"를 기록한다.
//
// window.history.length 는 새 탭으로 링크를 열었을 때도 2(about:blank + 첫 페이지)가 되므로,
// "뒤로 갈 수 있는지"의 신호로 쓰기엔 부정확하다 — router.back() 이 about:blank 로 빠지는
// 사고(U6-11 체크아웃)의 원인이었다. 여기 카운터는 클라이언트 라우팅이 실제로 한 번이라도
// 일어났을 때만 늘어나므로, "뒤로" 가 안전한지 판단하는 더 정확한 신호가 된다.
let inAppNavigationCount = 0;

export function markInAppNavigation(): void {
    inAppNavigationCount += 1;
}

export function hasInAppHistory(): boolean {
    return inAppNavigationCount > 0;
}
